import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';

import { NavItem } from './NavItem';

import { Colors } from '@/assets';
import { INavItem } from '@/types';

export const SubNavs = ({ navs, onClose }: { navs: INavItem[] | undefined; onClose: () => void }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                position: 'absolute',
                zIndex: 1,
                width: '50%',
                top: 0,
                left: navs ? '50%' : 0,
                transition: 'left 0.2s ease-in-out',
                px: 2,
                py: 3,
                borderRight: '1px solid',
                borderColor: Colors.greenWhite,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
                overflow: 'auto'
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {navs &&
                    navs.map((item, index) => {
                        const isActive = pathname.includes(item.path);
                        return (
                            <NavItem
                                key={index}
                                item={item}
                                active={isActive}
                                onClick={() => {
                                    navigate(item.path);
                                    onClose();
                                }}
                            />
                        );
                    })}
            </Box>
        </Box>
    );
};
